"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TickerTrack = exports.TickerText = exports.TickerItem = exports.TickerIcon = exports.TickerContent = exports.TickerContainer = void 0;
var _react = require("@linaria/react");
const TickerContainer = exports.TickerContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "TickerContainer",
  class: "tjbbc8j",
  vars: {
    "tjbbc8j-0": [({
      isMobile
    }) => isMobile ? '12px 0' : '18px 0']
  }
});
const TickerTrack = exports.TickerTrack = /*#__PURE__*/(0, _react.styled)("div")({
  name: "TickerTrack",
  class: "t1m3ct4j",
  vars: {
    "t1m3ct4j-0": [({
      delay
    }) => delay, "s"],
    "t1m3ct4j-1": [({
      direction
    }) => direction === 'left' ? 'normal' : 'reverse']
  }
});
const TickerContent = exports.TickerContent = /*#__PURE__*/(0, _react.styled)("div")({
  name: "TickerContent",
  class: "t1d4qri"
});
const TickerItem = exports.TickerItem = /*#__PURE__*/(0, _react.styled)("div")({
  name: "TickerItem",
  class: "t1phi23f",
  vars: {
    "t1phi23f-0": [({
      isMobile
    }) => isMobile ? '0 8px' : '0 16px'],
    "t1phi23f-1": [({
      isMobile
    }) => isMobile ? '16px' : '23px']
  }
});
const TickerIcon = exports.TickerIcon = /*#__PURE__*/(0, _react.styled)("span")({
  name: "TickerIcon",
  class: "tgmi0xl"
});
const TickerText = exports.TickerText = /*#__PURE__*/(0, _react.styled)("span")({
  name: "TickerText",
  class: "t16oe0oy",
  vars: {
    "t16oe0oy-0": [({
      bold
    }) => bold ? '850' : '450']
  }
});